import { createFileRoute } from "@tanstack/react-router";

import { ConnectGGCalendarCallback } from "@/features/office/schedule/_components/connect-gg-calendar-callback";

export const Route = createFileRoute("/office/connect-gg-calendar")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ConnectGGCalendarCallback />;
}
